module.exports = __webpack_public_path__ + "452ab8fb90f66192c390d963b338641f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flower-tulip.png
// module id = 2525
// module chunks = 0